import { styled, alpha } from "@mui/material/styles";
import { IconButton as MuiIconButton, Tab, Typography } from "@mui/material";
import Link from "next/link";


export const PanelContainer = styled("div")(({ theme }) => ({
  display: "flex",
  alignSelf: "stretch",
  width: "100%",
  flexDirection: "column",
}));

export const TabPanelBox = styled("div")(({ theme }) => ({
  display: "flex",
  alignSelf: "stretch",
  width: "100%",
  flexDirection: "column",
  gap: theme.space._500
}));

export const TabsContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.space._500,
  minWidth: "14rem",

  "& .MuiTabs-indicator": {
    background: "none",
  },

  "@media (max-width: 768px)": {
    display: "none",
  },
}));

export const StyledTab = styled(Tab)(({ theme }) => ({
  display: "flex",
  padding: `${theme.space._200} 0`,
  justifyContent: "flex-start",
  minHeight: "fit-content",
  gap: theme.space._300,
  alignItems: "center",

  textTransform: "unset",
  fontFamily: theme.fonts.default,
  fontSize: theme.fontSizes.md,
  lineHeight: theme.lineHeights.base,
  fontWeight: theme.fontWeights.regular,

  "&.MuiTab-root": {
    color: theme.colors["neutral.50"],

    "& .MuiTab-iconWrapper": {
      color: theme.colors["pink.500"],
    },

    "&.Mui-selected": {
      color: theme.colors["lime.500"],

      "& .MuiTab-iconWrapper": {
        color: theme.colors["lime.500"],
      },
    },
  },
}));

export const ProfilePageContainer = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "center",
  gap: theme.space._800,
  maxWidth: "57rem",
  paddingTop: "9rem",
  margin: "auto",

  backgroundColor: theme.colors["neutral.950"],

  color: theme.colors["neutral.50"],

  "@media (max-width: 900px)": {
    paddingLeft: theme.space._400,
    paddingRight: theme.space._400,
    paddingTop: "7rem",
  },
}));

export const HeaderContainer = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",

  gap: theme.space._300,
  marginBottom: theme.space._200,

  fontSize: theme.fontSizes.sm,
  fontFamily: theme.fonts.default,
}));

export const InfoContainer = styled("span")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.space._100,

  ".AccountMenu_username": {
    fontSize: theme.fontSizes.md,
    fontWeight: theme.fontWeights.bold,
  },
}));

export const TitleTypography = styled(Typography)(({ theme }) => ({
  fontFamily: theme.fonts.default,
  fontSize: theme.fontSizes["3xl"],
  fontWeight: theme.fontWeights.bold,
  lineHeight: theme.lineHeights.slim,
  color: theme.colors.white,
}));

export const SubTitleTypography = styled(Typography)(({ theme }) => ({
  fontFamily: theme.fonts.default,
  fontSize: theme.fontSizes.md,
  fontWeight: theme.fontWeights.regular,
  lineHeight: theme.lineHeights.slim,
  color: theme.colors["neutral.500"],
}));
